import { ref, watch, computed } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import Swal from 'sweetalert2'

export default function useUsersList(type) {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'created_date', sortable: true, label: 'Kayıt Tarihi' },
    { key: 'name_surname', sortable: true, label: 'Adı Soyadı' },
    {
      key: 'verify',
      label: 'Kayıt Durumu',
      formatter: title,
      sortable: true,
    },
    { key: 'verify_date', sortable: true },
    { key: 'actions' },
  ]
  if(type=='influencer'){
    tableColumns.splice(1, 0, { key: 'username', sortable: true, label: 'İnstagram Kullanıcı Adı' });
  }
  const perPage = ref(10)
  const deleted = ref(0)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const deletedFilter = ref('0')

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })
  
  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, deletedFilter], () => {
    refetchData()
  })
  const deleteUser = user => {

    Swal.fire({
      title: 'Emin Misiniz?',
      text: "Silinen fenomen arşiv'e kaldırılacaktır.",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'İptal',
      confirmButtonText: 'Evet!',
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        const data = {
          deleted:!user.deleted,
          user_type:type,
          id:user.id,
          email:user.email,
        }
        axiosIns
        .put(`user`,data)
        .then((result) => {
          if(result.data.success){
            Swal.fire({
              icon: 'success',
              title: 'Güncelleme işlemi tamamlandı',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            refetchData();
          }else{
            toast({
              component: ToastificationContent,
              props: {
                title: result.data.error,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Kullanıcı silinirken hata oluştu',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }
    }) ;
  }

  const fetchUsers = (ctx, callback) => {
    axiosIns
      .get('user', {
        params: {
          q: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          filter: {
            deleted:deletedFilter.value,
          },
          user_type:type,
          source: 'list',
        },
      })
      .then(response => {
        const users = response.data.data
        totalUsers.value = response.data.total;
        callback(users)
      })
      .catch(error => {
        // 401 hatası değilse uyarı göster
        if (!error.response || error.response.status !== 401) {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.error,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  const resolveUserVerify = verify => {
    if (verify == '0') return 'warning'
    if (verify == '1') return 'success'
    return 'primary'
  }

  return {
    fetchUsers,
    tableColumns,
    perPage,
    deleted,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    deleteUser,
    isSortDirDesc,
    refUserListTable,

    resolveUserVerify,
    refetchData,
    deletedFilter,

  }
}
